import { ListUnresolvedDepartmentsRequestSchema, ListUnresolvedDepartmentsResponseSchema } from './list-unresolved-departments.schema';
/**
 * List Unresolved Departments Contract
 * GET /api/v2/initialize/unresolved-departments
 * Returns all departments whose manager is still unresolved
 */ export const listUnresolvedDepartmentsContract = {
    method: 'GET',
    path: '/api/v2/initialize/unresolved-departments',
    requestSchema: ListUnresolvedDepartmentsRequestSchema,
    responseSchema: ListUnresolvedDepartmentsResponseSchema,
    statusCodes: {
        success: 200,
        errors: {
            401: 'Unauthorized - user not authenticated'
        }
    },
    description: 'Fetches all departments that are still awaiting manager resolution'
};

//# sourceMappingURL=list-unresolved-departments.contract.js.map